import styled from 'styled-components';

export const ROIFormContainer = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  padding: 32px 28px 66px;
  background-image: ${props => props.backgroundImg && `url(${props.backgroundImg})`};
  background-color: var(--white-color);
  background-position: 400px -650px;
  background-repeat: no-repeat;
  box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.1);
  border-radius: 0;

  .roi-form-section--back-icon {
    position: absolute;
    margin-left: 22px;
    margin-top: 8px;
    cursor: pointer;

    svg {
      width: 32px;
      height: 32px;

      path {
        stroke: black;
      }
    }
  }

  .roi-form-section--title {
    font-weight: 900;
    font-size: 49px;
    line-height: 110%;
    text-align: center;
    letter-spacing: -0.04em;
    color: var(--black-color);
    margin-bottom: 45px;
    padding: 0 70px;
  }

  .roi-form--description {
    max-width: 685px;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    text-align: right;
    color: var(--neutral-text-color);
    margin: 0 auto 24px;
  }

  .roi-form--form {
    max-width: 685px;
    margin: 0 auto;

    .roi-form--form-item {
      padding: 0;
      margin-bottom: 39px;

      .ant-select-selector {
        height: 58px !important;
      }

      .ant-select-selection__placeholder {
        color: var(--neutral-4);
      }
    }

    .roi-form-section--prev-button {
      color: var(--neutral-6);
      background: none !important;
      transition: none;
    }

    .roi-form-section--footer {
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-height: 121px;
    }

    .roi-form-section--button-container,
    .roi-form-section--last-button-container {
      display: flex;
      justify-content: center;
      width: 100%;

      button {
        max-width: 206px;
        margin: 0 20px;
      }

      .roi-form-section--contact-label {
        margin: 0;
        align-self: center;
        font-size: 20px;
        width: auto;

        &.label-success {
          color: green;
        }
      }

      .roi-form-section--contact-button {
        height: 48px;
        font-size: 16px;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 24px;
    background-position: -70px -630px;

    .roi-form-section--back-icon {
      margin-left: 26px;
      margin-top: 3px;

      svg {
        width: 20px;
        height: 20px;
      }
    }

    .roi-form-section--title {
      font-size: 29px;
    }

    .roi-form--form {
      max-width: 552px;

      .roi-form--form-item {
        margin-bottom: 24px;
      }

      .roi-form--submit-button {
        width: 100%;
      }
    }
  }

  @media (max-width: 576px) {
    padding: 20px 24px;
  }

  &.roi-form-section--container {
    padding: 55px 30px 50px;
    box-shadow: 0px 15px 40px rgb(11, 26, 33, 0.1);
    border-radius: 8px;

    .roi-form--form {
      max-width: 100%;

      .roi-form--form-item {
        padding: 0 20px;
        flex: 1;
        margin: 25px 0 15px;
      }
    }

    @media (max-width: 1075px) {
      .roi-form--form {
        .text-field-with-label--label {
          font-size: 18px;
        }
      }
    }

    @media (max-width: 952px) {
      .roi-form--form {
        .roi-form--form-item {
          flex: 0;
          margin: 15px 0 25px;
        }

        .roi-form-section--button-container {
          button {
            max-width: 100%;
            width: 100%;
          }
        }

        .roi-form-section--last-button-container {
          flex-direction: column;
          align-items: center;

          .roi-form-section--contact-label {
            font-size: 17px;
            text-align: center;
          }

          button {
            margin: 20px 0 0;
            width: 187px;
          }
        }
      }
    }

    @media (max-width: 768px) {
      padding: 55px 30px 50px;

      .roi-form-section--title {
        padding: 0 40px;
      }

      .roi-form--form {
        max-width: 100%;

        .roi-form--form-item {
          .text-field-with-label--input-container {
            .ant-select,
            input {
              height: 58px !important;

              .ant-select-selector {
                .ant-select-selection-item,
                .ant-select-selection-placeholder {
                  line-height: 58px !important;
                }
              }
            }
          }
        }
      }
    }

    @media (max-width: 576px) {
      padding: 40px 10px;

      .roi-form-section--title {
        margin-bottom: 15px;
      }

      .roi-form-section--button-container {
        padding: 0 10px;

        button {
          margin: 0 10px;
        }
      }
    }
  }
`;

export const ROIResultContainer = styled.div`
  max-width: 1252px;
  margin: 20px auto 50px;
  padding: 0 28px;
  width: 100%;

  .section-roi-result-hero--result-container {
    display: flex;
    width: 100%;

    .section-roi-result-hero--result-item {
      height: 322px;
      background: #002f44;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 24px;

      .section-roi-result-hero--result-item-title {
        font-weight: bold;
        font-size: 20px;
        line-height: 120%;
        text-align: center;
        letter-spacing: -0.01em;
        color: var(--blue-3-title-color);
        margin: 0;
      }

      .section-roi-result-hero--result-item-value {
        font-weight: 900;
        font-size: 61px;
        line-height: 110%;
        text-align: center;
        letter-spacing: -0.05em;
        color: var(--white-color);
        margin: 24px 0 30px;
      }

      &.active {
        background: #002738;
      }
    }
  }

  .section-roi-result-hero--share-outer-container {
    display: flex;
    background: var(--blue-7);
    align-items: center;
    justify-content: center;
    padding: 53px 39px;

    .section-roi-result-hero--share-title {
      font-weight: 900;
      font-size: 25px;
      line-height: 120%;
      text-align: right;
      letter-spacing: -0.02em;
      color: var(--white-color);
      margin: 0px 24px 0px 0px;
      min-width: 197px;
    }

    .section-roi-result-hero--share-container {
      height: 100px;
      background: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;

      .section-roi-result-hero--share-input-container {
        width: 100%;
        max-width: 526px;
        height: 62px;
        display: flex;
        padding: 0;

        & > div:first-child {
          width: 100%;
          .ant-row.ant-form-item:first-child {
            max-width: 500px !important;
            min-width: 50px !important;
          }
          button {
            min-width: 107px;
            margin-left: 0;
          }
        }
      }

      .section-roi-result-hero--share-splitter {
        width: 1px;
        height: 100%;
        border-left: 1px solid var(--input-selected-text-color);
        margin: 0 40px;
        opacity: 0.5;
      }

      .section-roi-result-hero--share-copy-btn {
        height: 48px;
        border: 1px solid #fff;
        background: transparent;
        font-weight: bold;
        font-size: 16px;
        line-height: 110%;
        text-align: center;
        color: var(--white-color);
        padding: 15px 24px;
        min-width: 121px;

        &:hover {
          background: #00000022;
        }
      }
    }
  }

  @media (max-width: 991px) {
    .section-roi-result-hero--share-outer-container {
      .section-roi-result-hero--share-title {
        text-align: left;
      }

      .section-roi-result-hero--share-container {
        .section-roi-result-hero--share-input-container {
          max-width: 100%;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .section-roi-result-hero--main {
      margin-top: 40px;

      .section-roi-result-hero--result-container {
        .section-roi-result-hero--result-item {
          height: 188px;

          .section-roi-result-hero--result-item-title {
            font-size: 18px;
          }

          .section-roi-result-hero--result-item-value {
            font-size: 48px;
            margin: 16px 0 0;
          }
        }
      }

      .section-roi-result-hero--share-outer-container {
        flex-direction: column;
        align-items: center;
        padding: 32px 0;

        .section-roi-result-hero--share-title {
          font-size: 20px;
          letter-spacing: -0.01em;
          text-align: center;
          margin: 0;
        }

        .section-roi-result-hero--share-container {
          flex-direction: column;
          height: auto;
          margin-top: 10px;

          .section-roi-result-hero--share-splitter {
            width: 100%;
            height: 1px;
            border-left: none;
            border-top: 1px solid var(--normal-description-color);
            margin: 10px 0 12px;
          }

          .section-roi-result-hero--share-copy-btn {
            width: 100%;
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    .section-roi-result-hero--main {
      padding: 0 20px;

      .section-roi-result-hero--result-container {
        flex-direction: column;

        .section-roi-result-hero--result-item {
          height: 225px;
        }
      }
    }
  }

  &.roi-result-section--container {
    margin: 0 auto 39px;

    .section-roi-result-hero--result-container {
      .section-roi-result-hero--result-item {
        height: 151px;
        background: var(--white-color);

        .section-roi-result-hero--result-item-title {
          color: var(--blue-7);
        }

        .section-roi-result-hero--result-item-value {
          margin: 20px 0 0;
          color: var(--black-color);
        }
      }
    }

    @media (max-width: 952px) {
      .section-roi-result-hero--result-container {
        flex-direction: column;

        .section-roi-result-hero--result-item {
          height: 131px;

          .section-roi-result-hero--result-item-title {
            font-size: 18px;
          }

          .section-roi-result-hero--result-item-value {
            font-size: 32px;
          }
        }
      }
    }
  }
`;

export const ROIResultHowContainer = styled.div`
  background: ${props => props.background};

  .section-roi-result-how--container {
    padding: 50px 28px 61px;

    .section-roi-result-how--title {
      font-weight: 900;
      font-size: 49px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.04em;
      color: var(--normal-title-color);
    }

    .section-roi-result-how--video-content {
      padding: 0 54px;
      position: relative;
      max-width: 864px;
      margin: 50px auto 0;

      .VideoMainDiv {
        box-shadow: 0px 40px 60px rgba(0, 0, 0, 0.15);
      }

      .section-roi-result-how--video-container {
        position: relative;

        &:before {
          content: '';
          position: absolute;
          background: var(--secondary-green-background);
          width: 211px;
          height: 42px;
          bottom: -42px;
          right: -42px;
        }

        &:after {
          content: '';
          position: absolute;
          background: var(--secondary-green-background);
          width: 42px;
          height: 211px;
          bottom: -42px;
          right: -42px;
        }
      }
    }

    .section-roi-result-how--main {
      max-width: 1250px;
      padding: 0;
      margin: 135px auto 0;

      .section-roi-result-how--item-column {
        display: flex;
        width: 100%;

        .section-roi-result-how--item {
          padding: 0 21px;
          margin-bottom: 48px;
          flex: 1;

          &:first-child {
            padding-left: 0;
          }

          &:last-child {
            padding-right: 0;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .section-roi-result-how--container {
      padding: 30px 28px 48px;

      .section-roi-result-how--title {
        font-size: 29px;
        letter-spacing: -0.03em;
      }

      .section-roi-result-how--video-content {
        max-width: 590px;
        padding: 0;

        .section-roi-result-how--video-container {
          &:before,
          &:after {
            display: none;
          }
        }
      }

      .section-roi-result-how--main {
        margin-top: 80px;

        .section-roi-result-how--item-column {
          .section-roi-result-how--item {
            padding: 0 10px;
            margin-bottom: 20px;

            .ant-card-body {
              padding: 16px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    .section-roi-result-how--container {
      padding: 30px 20px 48px;

      .section-roi-result-how--video-content {
        .section-roi-result-how--video-container {
          &:before {
            display: block;
            width: 100px;
            height: 13px;
            bottom: -13px;
            right: -13px;
          }

          &:after {
            display: block;
            width: 13px;
            height: 100px;
            bottom: -13px;
            right: -13px;
          }
        }
      }

      .section-roi-result-how--main {
        margin-top: 40px;

        .section-roi-result-how--item-column {
          flex-direction: column;

          .section-roi-result-how--item {
            padding: 0;

            &:first-child {
              padding: 0;
            }

            &:last-child {
              padding: 0;
            }

            .ant-card-body {
              padding: 16px;

              .industry-card--container {
                display: flex;

                .industry-card--content-container {
                  padding-left: 20px;
                  padding-top: 0;

                  .industry-card--description {
                    margin: 8px 0 0;
                    padding: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
